import Const from 'constants';

let OpposingPlayers = {
    setOpposingPlayersFromStorage(opposingPlayers) {
        return (dispatch) => {
            dispatch(this.setOpposingPlayers(opposingPlayers, {saveToStorage: false}));
        };
    },

    setOpposingPlayers(opposingPlayers, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_OPPOSING_PLAYERS,
                opposingPlayers,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('opposingPlayers', function (state) {
                    const {
                        filters: {opposingPlayers},
                    } = state.lineupsData;

                    return opposingPlayers;
                }),
            );
        };
    },
};

export default OpposingPlayers;
